import { render, staticRenderFns } from "./ProcurementReportGeneralLedger.vue?vue&type=template&id=33211487"
import script from "./ProcurementReportGeneralLedger.vue?vue&type=script&lang=js"
export * from "./ProcurementReportGeneralLedger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports